export default class CommonEventsKey {
  static commonEventKeys() {
    let COMMON_EVENTS_KEY = {
      APP_SESSION_USER_ID: "app_user_id",
      APP_SESSION_DEVICE_ID: "app_device_id",
      APP_SESSION_USER_AGENT: "app_user_agent",
      APP_SESSION_EVENT_TYPE: "app_event_type",
      APP_SESSION_SESSION_ID: "app_session_id",
      APP_SESSION_EVENT: "app_event",
      APP_SESSION_WALL_CLOCK: "app_wall_clock",
      APP_SESSION_TIME_ZONE: "app_time_zone",
      APP_SESSION_SUBSCRIBE_TYPE: "app_subscribe_type",
      APP_SESSION_PLATFORM_TYPE: "app_platform_type",
      APP_SESSION_PARTNER_ID: "app_partner_id",
      APP_SESSION_APPLICATION_VERSION: "app_version",
      APP_SESSION_BUILD_VERSION: "app_build_version",
      APP_SESSION_GEO_LOCATION: "app_geo_location",
      APP_SESSION_HARDWARE: "app_hardware",
      APP_SESSION_OPERATING_SYSTEM: "app_operating_system",

      APP_PROFILE_ID:"app_profile_id",
      APP_PPID:"app_ppid",
      APP_SLIV_PROFILE_ID:"app_sliv_profile_id",
      APP_USER_AGE:"app_user_age",
      APP_USER_GENDER:"app_user_gender",

      VIDEO_SESSION_EVENT_TYPE: "video_event_type",
      VIDEO_SESSION_ID: "video_session_id",
      VIDEO_SESSION_NETWORK_TYPE: "video_network_type",
      VIDEO_SESSION_CONNECTION_SPEED: "video_connection_speed",
      VIDEO_SESSION_DEVICE_RESOLUTION: "video_device_resolution",
      VIDEO_SESSION_EVENT: "video_event",
      VIDEO_SESSION_WALL_CLOCK: "video_wall_clock",
      VIDEO_SESSION_VIDEO_TYPE: "video_video_type",
      VIDEO_SESSION_PLAYER_NAME: "video_player_name",
      VIDEO_SESSION_PLAYER_VERSION: "video_player_version",
      VIDEO_SESSION_CONTENT_FORMAT: "video_content_format",
      VIDEO_SESSION_DRM: "video_drm",
      VIDEO_SESSION_CODEC: "video_codec",
      VIDEO_SESSION_CDN: "video_cdn",
      VIDEO_SESSION_SESSION_CLASSIFIER_EXPERIMENT_ID:
        "video_session_classifier_experiment_id",
      VIDEO_SESSION_CONTENT_ID: "video_content_id",
      VIDEO_SESSION_DELIVERY_PROTOCOL: "video_delivery_protocol",
      VIDEO_SESSION_PLAYING_RATE: "video_playing_rate",
      VIDEO_SESSION_STARTING_BITRATE: "video_starting_bitrate",
      VIDEO_SESSION_SESSION_TYPE: "video_session_type",
      VIDEO_SESSION_PLATFORM: "video_platform_type",
      VIDEO_SESSION_PARTNER_ID: "video_partner_id",
      VIDEO_SESSION_APPLICATION_VERSION: "video_application_version",
      VIDEO_SESSION_BUILD_VERSION: "video_build_version",
      VIDEO_SESSION_GEO_LOCATION: "video_geo_location",
      VIDEO_SESSION_HARDWARE: "video_hardware",
      VIDEO_SESSION_OPERATING_SYSTEM: "video_operating_system",
      VIDEO_SESSION_NETWORK_TYPE: "video_network_type",
      VIDEO_SESSION_CONNECTION_SPEED: "video_connection_speed",
      VIDEO_SESSION_TIME_TO_FIRST_BYTE: "video_time_to_first_byte",
      VIDEO_SESSION_CONNECT_TIME: "video_connect_time",
      VIDEO_SESSION_VIDEO_RESOLUTION: "video_resolution",
      VIDEO_SESSION_VIDEO_POSITION: "video_position",
      VIDEO_SESSION_VIDEO_END_CODE: "video_end_codec",
      VIDEO_SESSION_VIDEO_STREAMING_MODE: "video_streaming_mode",
      VIDEO_SESSION_SUMMARY: "video_summary",
      VIDEO_SESSION_VIDEO_LENGTH: "video_length",
      VIDEO_SESSION_WAT: "video_wat",
      VIDEO_SESSION_SEQUENCE: "video_sequence",
      // NEW KEYS ADDED
      VIDEO_SESSION_CURRENT_BITRATE: "video_current_bitrate",
      VIDEO_SESSION_AUDIO_LANGUAGE: "video_audio_language",
      VIDEO_SESSION_SUBTITLE_LANGUAGE: "video_subtitle_language",
      VIDEO_SESSION_STREAMING_HOST: "video_streaming_host",
      VIDEO_SESSION_CONTENT_PREFETCH: "video_content_prefetch",
      VIDEO_SESSION_BINGE: "video_binge",
      VIDEO_SESSION_18PLUS: "video_18plus",
      VIDEO_SESSION_START_TIME: "video_session_start_time",
      FROM_AUDIO_LANGUAGE: "from_audio_language",
      TO_AUDIO_LANGUAGE: "to_audio_language",
      FROM_SUBTITLE_LANGUAGE: "from_subtitle_language",
      TO_SUBTITLE_LANGUAGE: "to_subtitle_language",
      VIDEO_SESSION_WATCH_TIME_DURATION: "video_session_watch_time_duration",
      VIDEO_INCREMENT_BUFFER_TIME_DURATION: "video_increment_buffer_time_duration",
      NORMALIZED_WATCH_TIME:"normalized_watch_time",
      VIDEO_MONETIZABLE_VIDEO_VIEWS:"video_monetizable_video_views",

      VIDEO_STREAMING_HEARTBEAT_EVENT: "heartbeat_event_type",
      VIDEO_STREAMING_HEARTBEAT_WALL_CLOCK: "heartbeat_wall_clock",
      VIDEO_STREAMING_HEARTBEAT_W_START_TIME: "heartbeat_w_start_time",
      VIDEO_STREAMING_HEARTBEAT_W_END_TIME: "heartbeat_w_end_time",
      VIDEO_STREAMING_HEARTBEAT_START_POSITION: "heartbeat_start_position",
      VIDEO_STREAMING_HEARTBEAT_END_POSITION: "heartbeat_end_pposition",
      VIDEO_STREAMING_HEARTBEAT_DURATION: "heartbeat_duration",
      VIDEO_STREAMING_HEARTBEAT_DROPPED_FRAME: "heartbeat_dropped_frame",
      VIDEO_STREAMING_HEARTBEAT_BUFFER_HEALTH: "heartbeat_buffer_health",
      VIDEO_STREAMING_HEARTBEAT_NETWORK_ACTIVITY: "heartbeat_network_activity",
      VIDEO_STREAMING_HEARTBEAT_NETWORK_DOWNLOAD_SPEED:
        "heartbeat_network_download_speed",
      VIDEO_STREAMING_HEARTBEAT_CONTENT_TYPE: "heartbeat_content_type",
      VIDEO_STREAMING_HEARTBEAT_VIDEO_RESOLUTION: "heartbeat_video_resolution",
      VIDEO_STREAMING_HEARTBEAT_VIDEO_PORT_SIZE: "heartbeat_video_port_size",
      VIDEO_STREAMING_HEARTBEAT_LIVE_LATENCY: "heartbeat_live_latency",
      VIDEO_STREAMING_HEARTBEAT_NETWORK_CHANGE: "heartbeat_network_change",
      VIDEO_STREAMING_HEARTBEAT_SEQUENCE: "heartbeat_sequence",
      VIDEO_STREAMING_HEARTBEAT_NETWORK_BANDWIDTH_BUCKET: "network_bandwidth_bucket",
      VIDEO_STREAMING_HEARTBEAT_CURRENT_BITRATE: "current_bitrate",

      EVENT_CURRENT_PLAYBACK_RATE:"event_current_playback_rate",
      EVENT_FORMER_PLAYBACK_RATE:"event_former_playback_rate",
      EVENT_PLAYING_STATE:"event_playing_state",
      
      // custom tag key
      VIDEO_ENTRY_POINT : "video_entry_point",
      SUBSCRIBED_PACK_NAME:"subscribed_pack_name",
      SUBSCRIBED_PACK_RESOLUTION:"subscribed_pack_resolution",
      MAX_ENTITLED_VIDEO_RESOLUTION:"max_entitled_video_resolution",
      INITIAL_VIDEO_SETTING:"initial_video_setting",
      UPDATED_VIDEO_SETTING:"updated_video_setting",
      IS_MULTICAM_ASSET:"is_multicam_asset",
      VIDEO_PARENT_ID:"video_parent_id",
      VIDEO_PT_SP_KEY:"video_pt_sp_key",
      VIDEO_END_REASON:"video_end_reason",
      VIDEO_PLAYBACK_STATE:"video_playback_state",
      VIDEO_SSAI_ID:"video_ssai_id",
      SSAI_STITCHER:"ssai_stitcher",
      GA_SESSION_ID:"ga_session_id",

      // Ads constant keys
      ADS_EVENT_TYPE: "ads_event_type",
      ADS_CAMPAIGN_ID: "ads_campaign_id",
      ADS_ADVERTISER_ID: "ads_advertiser_id",
      ADS_CURRENT_AD_COUNT: "ads_current_ad_count",
      ADS_CONFIGURED_AD_COUNT: "ads_configured_ad_count",
      ADS_POSITION: "ads_position",
      ADS_POD_POSITION: "ads_pod_position",
      ADS_LENGTH_WATCHED : "ads_length_watched",
      ADS_LENGTH_DURATION: "ads_length_duration",
      ADS_ASSET_NAME: "ads_asset_name",
      ADS_STREAM_URL: "ads_stream_url",
      ADS_TECHNOLOGY: "ads_technology",
      ADS_SYSTEM: "ads_system",
      ADS_ADVERTISER: "ads_advertiser",
      ADS_CREATIVE_ID: "ads_creative_id",
      ADS_DESCRIPTION: "ads_description",
      ADS_STICHER: "ads_stitcher",
      ADS_IS_SLATE: "ads_is_slate",
      ADS_MEDIA_FILE_API_FRAMEWORK: "ads_media_file_api_framework",
      ADS_MANAGER_NAME: "ads_manager_name",
      ADS_MANAGER_VERSION: "ads_manager_version",
      ADS_FIRST_AD_SYSTEM: "ads_first_ad_system",
      ADS_FIRST_AD_ID: "ads_first_ad_id",
      ADS_FIRST_CREATIVE_ID: "ads_first_creative_id",
      ADS_CURRENT_BITRATE: "ads_current_bitrate",
      
      ADS_POD_AD_POSITION:"ads_pod_ad_position",
      ADS_POD_MAX_AD_COUNT:"ads_pod_max_ad_count",
      ADS_PREVIOUS_POD:"ads_previous_pod",
      ADS_AD_BUFFER_DURATION:"ads_ad_buffer_duration",

      ADS_CLUSTER_ID:"ads_cluster_id",
      ADS_CAMPAIGN_NAME:"ads_campaign_name",
      ADS_WATCH_TIME_DURATION:"ads_watch_time_duration",
      ADS_ABA_EXPERIMENT_NAME:"ads_ABA_experiment_name",
      ADS_ABA_EXPERIMENT_VARIANT_NAME:"ads_ABA_experiment_variant_name",
      ADEND_EVENT_INITIATOR:"adend_event_initiator",

      EVENT_EVENT: "event_event_type",
      EVENT_WALL_CLOCK: "event_wall_clock",
      EVENT_TIME_ZONE: "event_time_zone",
      EVENT_FTL: "event_ftl",
      EVENT_ERROR_CODE: "event_error_code",
      EVENT_ERROR_MESSAGE: "event_error_message",
      EVENT_EXCEPTION_TRACE: "event_exception",
      EVENT_VIDEO_END_CODE: "event_video_end_code",
      EVENT_VIDEO_SESSION_SUMMARY: "event_video_session_summary",
      EVENT_START_POSITION: "event_start_position",
      EVENT_END_POSITION: "event_end_position",
      EVENT_DURATION: "event_duration",
      EVENT_DATA_LIST: "event_data_list",
      EVENT_FROM_BITRATE: "event_from_bitrate",
      EVENT_TO_BITRATE: "event_to_bitrate",
      EVENT_INCREMENT_NUMBER: "event_increment_number", //df
      EVENT_BUFFER_HEALTH: "event_buffer_health",
      EVENT_NETWORK_ACTIVITY: "event_network_activity",
      EVENT_VIDEO_RESOLUTION: "event_video_resolution",
      EVENT_VIEWPORT_SIZE: "event_viewport_size",
      EVENT_LIVE_LATENCY: "event_live_latency",
      EVENT_NETWORK_CONNECTIVITY: "event_network_connectivity",
      EVENT_NET_DOWNLOAD_SPEED: "event_net_download_speed",
      EVENT_CONTENT_TYPE: "event_content_type",
      EVENT_ADMRK_ID:"event_admrk_id",
      EVENT_ADPOS:"event_adpos",
      EVENT_ADCNT:"event_adcnt",

      CUSTOMTAG_COLOUR: "customtag_colour",
      CUSTOM_TAGS: "custom_tags",

      //heartbeat events name for player
      HEART_BEAT_EVENT_SEEK: "heart_beat_event_seek",
      HEART_BEAT_EVENT_BUFFER: "heart_beat_event_buffer",
      HEART_BEAT_EVENT_PAUSE: "heart_beat_event_pause",
      HEART_BEAT_EVENT_RESUME: "heart_beat_event_resume",
      HEART_BEAT_EVENT_UPSHIFT: "heart_beat_event_upshift",
      HEART_BEAT_EVENT_DOWNSHIFT: "heart_beat_event_downshift",
      HEART_BEAT_EVENT_DROPPED_FRAMES: "heart_beat_event_dropped_frames",
      HEART_BEAT_EVENT_BUFFER_HEALTH: "heart_beat_event_buffer_health",
      HEART_BEAT_EVENT_NETWORK_ACTIVITY: "heart_beat_event_network_activity",
      HEART_BEAT_EVENT_VIDEO_RESIZE: "heart_beat_event_video_resize",
      HEART_BEAT_EVENT_GOLIVE: "heart_beat_event_golive",
      HEART_BEAT_EVENT_NETWORK_CHANGE: "heart_beat_event_network_change",
      HEART_BEAT_EVENT_AUDIO_LANGUAGE: "heart_beat_event_audio_language",
      HEART_BEAT_EVENT_SUBTITLE_LANGUAGE: "heart_beat_event_subtitle_language",
      HEART_BEAT_EVENT_BUFFER_START: "heart_beat_event_buffer_start",
      HEART_BEAT_EVENT_BUFFER_END: "heart_beat_event_buffer_end",
      HEART_BEAT_EVENT_NETWORK_BANDWIDTH: "heart_beat_network_bandwidth",
      HEART_BEAT_SPEED_CHANGE: "heart_beat_speed_change",
      HEART_BEAT_LIVE_TO_AD:"heart_beat_live_to_ad",
      HEART_BEAT_LIVE_TO_AD_TO_LIVE:"heart_beat_live_to_ad_to_live",
      HEART_BEAT_AD_TO_LIVE:"heart_beat_ad_to_live",
      HEART_BEAT_AD_SKIP_TRUE_VIEW:"heart_beat_ad_skip_true_view",

      //heartbeat ads event
      HEART_BEAT_ADS_EVENT_AD_CLICK: "heart_beat_ads_event_ad_click",
      HEART_BEAT_ADS_EVENT_AD_SKIP: "heart_beat_ads_event_ad_skip",
      HEART_BEAT_ADS_EVENT_AD_BUFFER: "heart_beat_ads_event_ad_buffer",
      HEART_BEAT_ADS_EVENT_AD_PAUSE: "heart_beat_ads_event_ad_pause",
      HEART_BEAT_ADS_EVENT_AD_RESUME: "heart_beat_ads_event_ad_resume",
      HEART_BEAT_EVENT_AD_CLICK_URL: "heart_beat_event_ad_click_url",
      HEART_BEAT_EVENT_AD_BUFFER_DUR: "heart_beat_event_ad_buffer_dur",
      HEART_BEAT_ADS_EVENT_AD_BUFFER_START: "heart_beat_ads_event_ad_buffer_start",
      HEART_BEAT_ADS_EVENT_AD_BUFFER_END: "heart_beat_ads_event_ad_buffer_end",

      // Pulse player events
      PULSE_EVENT_NAME:"pulse_event_name",
      PULSE_EVENT_COUNT_SEQUENCE: "pulse_event_count_sequence",
      PULSE_START_STEPS: "pulse_start_steps",
      PULSE_MICRO_STEPS: "pulse_micro_steps",
      PULSE_PLAYER_STATE: "pulse_player_state",
      PULSE_PLAYER_RETRY: "pulse_player_retry",

    };
    return COMMON_EVENTS_KEY;
  }
}
